<template>
  <div>
    <validation-provider
      :name="$t(config.name)"
      :rules="config.rules"
      v-slot="{ errors }"
    >
      <label class="d-block">
        {{ $t(config.label) }}
      </label>
      <v-select
        v-model="model"
        :options="routerOptions"
        :clearable="true"
        :disabled="!selectedUnit"
        :reduce="router => router.value"
        input-id="additional_router_select"
        @input="$emit('input', model)"
      />
      <p v-if="!selectedUnit" class="mb-0 small text-muted">
        {{ $t('commands.form.additional_router.hint') }}
      </p>
      <p v-if="errors[0]" class="small text-danger">{{ errors[0] }}</p>
    </validation-provider>
  </div>
</template>

<script>
import vSelect from 'vue-select';
import { ValidationProvider } from 'vee-validate';
import store from '@/store';

export default {
  components: {
    vSelect,
    ValidationProvider,
  },
  props: {
    value: [Number, String, Object],
    config: Object,
    context: Object,
  },
  data() {
    return {
      model: this.value ?? null,
    };
  },
  computed: {
    selectedUnitId() {
      return this.context?.model?.units ?? null;
    },
    selectedUnit() {
      if (!this.selectedUnitId || this.selectedUnitId === 'from_alarm') {
        return null;
      }

      return store.getters['unit/getItemById'](this.selectedUnitId);
    },
    routerOptions() {
      return (this.selectedUnit?.additional_routers_all ?? [])
        .filter(router => router?.id)
        .map(router => ({
          value: router.id,
          label: router.ip_vpn
            ? `${router.imei || `Router ${router.id}`} · ${router.ip_vpn}`
            : router.imei || `Router ${router.id}`,
        }));
    },
  },
  watch: {
    selectedUnitId() {
      const routerIsAvailable = this.routerOptions.some(
        router => String(router.value) === String(this.model)
      );

      if (this.model !== null && !routerIsAvailable) {
        this.model = null;
        this.$emit('input', null);
      }
    },
    value(value) {
      this.model = value ?? null;
    },
  },
};
</script>
